import { useAuth } from "../contexts/auth"
import AuthenticatedRoutes from "./AuthenticatedRoutes"
import NonAuthenticatedRoutes from "./NonAuthenticatedRoutes"

export default function Routes() {

    const { signed } = useAuth()

    return (
        signed ?
            <AuthenticatedRoutes />
            :
            <NonAuthenticatedRoutes />
    )
}